import React from 'react'
import { withRouter } from "react-router-dom";
import { Dialog, DialogContent, Button, DialogTitle, DialogActions, Snackbar, Slide, } from '@material-ui/core';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import Entrega from './Entrega';
import Salida from './Salida';
import Pdf from '../../../components/pdfViewer'
import Http from "../../../Http";
import ACCESS from '../../../ACCESS';

class Entregas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'entrega/filter', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Asignacion a transportista', [
        // { label: 'Folio', id: 'entrega' },
        { label: 'Folio', id: 'id' },
        { label: 'Fecha', id: 'fecha' },
        { label: 'Fecha de salida', id: 'ead_fecha' },
        { label: 'Chofer', id: 'transportista' },
        // { label: 'Fecha de entrega', id: 'fecha_entrega' },
      ], [
        { id: 'salida', icon: 'assignment', access: [ACCESS.ASIGNACION_TRANSPORTISTA.MARCAR_SALIDA_A_ASIGNACIONES_CREADAS_POR_EL_USUARIO,
          ACCESS.ASIGNACION_TRANSPORTISTA.MARCAR_SALIDA_A_ASIGNACIONES_DE_SUCURSAL_DEL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.MARCAR_SALIDA_A_TODOS_LAS_ASIGNACIONES
        ]},
        { id: 'ver', icon: 'visibility', access: [ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_CREADAS_POR_EL_USUARIO, 
          ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_SUCURSAL_DEL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.VER_TODAS_ASIGNACIONES] },
        { id: 'timbrar_carta_porte', icon: 'notifications', tooltip: 'Carta Porte', access: [ACCESS.ASIGNACION_TRANSPORTISTA.GENERAR_CARTA_PORTE] },
      ]))
    this.table();
  }

  action = (id, row) => {
    if (id === 'salida') {
      this.setState({ dRow: row, dellOpen: true });
    } else if (id === 'ver') {
      this.setState({ dRow: row, demOpen: true });
    } else if (id === "timbrar_carta_porte") { 
      this.setState({ dRow: row });
      this.getCartaPorte(row.id);
    }
  }

  crearEmbarque = () => {
    this.setState({ demOpen: true })
  }

  guardadoEmbarque = () => {
    this.setState({ demOpen: false, dRow: {} });
    this.table();
  }

  guardadoLlegada = () => {
    this.setState({ dellOpen: false });
    this.table();
  }

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  };

  getCartaPorte = async (id) => {
    this.setState({ loading: true }); 
    if (!this.state.loadingCartaPorte) {
      this.setState({ loadingCartaPorte: true }); 
      const Res = await Http.get(`entrega/carta-porte/${id}`);
      if (!Res.error) {
        this.setState({ loading: false, dOpen: false, loadingCartaPorte: false });
        await this.downloadPDFReport(id);
      } else {
        this.setState({
          loading: false,
          sbMsg: `preguia #${id} ${Res.errMsg}`,
          sbOpen: true,
          loadingCartaPorte: false,
        });
      }
    }
    this.setState({ loading: false }); 
  }

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = pdfURL;
    a.download = `carta_porte.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  };

  handledownloaZip = async () => {
    const { dRow } = this.state;
    const Resp = await Http.get(
      `carta-porte/xml?iddocumento=${dRow.id}&tipo=3`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const zipURL = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = zipURL;
      a.download = `cartas_porte_${dRow.id}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(zipURL);
    }
  };

  downloadPDFReport = async (id) => {
    const Resp = await Http.get(
      `carta-porte/pdf-entrega/${id}`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        pdfURL: URL.createObjectURL(blob),
        viewPdf: true,
      });
    }
  };

  render() {
    const { dRow= {},
    demOpen = false, 
    dellOpen = false, 
    viewPdf = false, 
    pdfURL, 
    sbOpen = false, 
    sbMsg 
    } = this.state;
    const { hasAccess } = this.context
    return (
      <div>
        <div style={{ padding: 20 }}>
          <div style={{ textAlign: 'right' }}>
            { hasAccess([ACCESS.ASIGNACION_TRANSPORTISTA.CREAR_ASIGNACION_TRANSPORTISTA]) &&
              <Button variant='contained' color='primary' onClick={this.crearEmbarque}>Crear Asignacion a Transportista</Button>
            }
          </div>
          <this.TableRender />
        </div>

        <div>
          <Dialog
            open={demOpen ? demOpen : false}
            onClose={(event, reason) =>{ 
              if (reason !== "escapeKeyDown") {    
                this.setState({ demOpen: false, dRow: {} })
              }
            }}
            fullScreen
          >
            <DialogContent>
              <Entrega onSave={this.guardadoEmbarque} id={dRow ? dRow.id : null} />
            </DialogContent>
          </Dialog>
        </div>

        <div>
          <Dialog
            open={dellOpen ? dellOpen : false}
            onClose={() => this.setState({ dellOpen: false })}
            maxWidth='lg'
            fullWidth
          >
            <DialogContent>
              <Salida id={dRow.id} onSave={this.guardadoLlegada} />
            </DialogContent>
          </Dialog>
        </div>
        
        
        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <Pdf pdfUrl={pdfURL} />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>Cancelar</Button>
            <Button variant="contained" onClick={this.handledownloadPdf}>
              Descargar PDF
            </Button>
            <Button variant="contained" onClick={this.handledownloaZip}>
              Descargar XML
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          resumeHideDuration={2000}
          autoHideDuration={2000}
          open={sbOpen === undefined ? false : sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    )
  }
}

export default withRouter(Entregas)